import React,{useState,useEffect,useCallback}from'react';
import{X,Copy,Check,Lock}from'lucide-react';
import{theme}from'./theme';
import{apiCall}from'./api';
export default function ShareModal({file,token,onClose}){
  const[link,setLink]=useState('');
  const[loading,setLoading]=useState(false);
  const[error,setError]=useState('');
  const[copied,setCopied]=useState(false);
  const createShare=useCallback(async()=>{setLoading(true);setError('');try{const d=await apiCall('/shares',token,{method:'POST',body:JSON.stringify({fileId:file.id})});const t=d?.shareToken||d?.token||d?.id||'';setLink(`${window.location.origin}/shared/${t}`);}catch(e){setError(e.message);}finally{setLoading(false);};},[file,token]);
  useEffect(()=>{createShare();},[createShare]);
  const copy=()=>{navigator.clipboard.writeText(link);setCopied(true);setTimeout(()=>setCopied(false),2000);};
  return<div style={{position:'fixed',inset:0,background:'rgba(0,0,0,0.6)',display:'flex',alignItems:'center',justifyContent:'center',zIndex:100}}>
    <div style={{width:440,background:theme.bgCard,borderRadius:theme.radius,padding:24,border:`1px solid ${theme.border}`}}>
      <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:18}}>
        <div><h3 style={{color:theme.text,fontSize:15,fontWeight:500,margin:0}}>Share file</h3><p style={{color:theme.textFaint,fontSize:12,marginTop:3}}>{file.fileName}</p></div>
        <button onClick={onClose} style={{background:'none',border:'none',color:theme.textFaint,cursor:'pointer',display:'flex'}}><X size={18}/></button>
      </div>
      {loading&&<p style={{color:theme.textFaint,fontSize:13}}>Generating link…</p>}
      {error&&<p style={{color:'#F09595',fontSize:13}}>{error}</p>}
      {link&&<div>
        <p style={{color:theme.textFaint,fontSize:12,marginBottom:8,display:'flex',alignItems:'center',gap:6}}><Lock size={12}/>Anyone with this link can download the file</p>
        <div style={{display:'flex',gap:8}}>
          <input readOnly value={link} style={{flex:1,background:theme.bgPanel,border:`1px solid ${theme.border}`,borderRadius:7,padding:'9px 12px',fontSize:12,color:theme.textMuted,outline:'none'}}/>
          <button onClick={copy} style={{display:'flex',alignItems:'center',gap:6,background:copied?theme.success:theme.accent,color:'#fff',border:'none',padding:'9px 14px',borderRadius:7,fontSize:12.5,cursor:'pointer'}}>{copied?<Check size={14}/>:<Copy size={14}/>}{copied?'Copied!':'Copy'}</button>
        </div>
      </div>}
    </div>
  </div>;
}
